module.exports = __webpack_public_path__ + "files/6b0312c8f6618521ca5a14cbe13db7e4.png";